import * as React from 'react';
import styled from 'styled-components';

import { Icon, IconStyled } from '@longline/aqua-ui/controls/Icon';
import { SVG } from '@longline/aqua-ui/svg';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
}

const LayerManagerWarningBase = (props: IProps) =>
  <div className={props.className}>
    <Icon url={SVG.Icons.Info} circle/>
    {props.children}
  </div>

const LayerManagerWarning = styled(LayerManagerWarningBase)`
  display: flex;
  gap: 8px;
  align-items: center;
  ${IconStyled} {
    border-color: ${p => p.theme.colors.accent};
    fill: ${p => p.theme.colors.accent};
  }
`

export { LayerManagerWarning }
